import { create } from 'zustand';
import { Role } from '@shared/permissions';

interface Team {
  id: string;
  displayname: string;
  created_at: string;
}

export interface TeamMember {
  id: string;
  user_id: string;
  email: string;
  displayname: string;
  photourl: string | null;
  role: Role;
  created_at: string;
  updated_at: string;
  /** Shared inbox Handle (jflo/<handle> Gmail label). */
  handle?: string | null;
}

interface TeamStore {
  currentTeam: Team | null;
  members: TeamMember[];
  setCurrentTeam: (team: Team | null) => void;
  setMembers: (members: TeamMember[]) => void;
}

export const useTeamStore = create<TeamStore>((set) => ({
  currentTeam: null,
  members: [],
  setCurrentTeam: (team) => set({ currentTeam: team }),
  setMembers: (members) => set({ members }),
})); 